/**
 * 2026.2 — knowledge base ASSEMBLY.
 *
 * Wires the FY27 rates + thresholds + references into a single
 * `AtoKnowledgeBase`, validated at import-time by Zod. Bumped from
 * 2026.1 to capture the cents-per-km rise to 91c/km effective 1 Jul
 * 2026, the FY27 super concessional cap rise to $32,500, and the
 * ongoing WFH fixed rate at 70c/hr + IAWO at $20,000.
 */

import {
  AtoKnowledgeBaseSchema,
  type AtoKnowledgeBase,
} from "../types";
import { rates } from "./rates";
import { thresholds } from "./thresholds";
import { references } from "./references";

const raw: AtoKnowledgeBase = {
  version: "2026.2",
  rates,
  thresholds,
  references,
  effective: {
    financialYearStart: "2026-07-01",
    financialYearEnd: "2027-06-30",
    note: "FY27 baseline. Cents-per-km 91c (up from 88c FY26). WFH held at 70c/hr. IAWO held at $20,000.",
  },
};

export const knowledge_2026_2: AtoKnowledgeBase =
  AtoKnowledgeBaseSchema.parse(raw);
